import { gql } from "@apollo/client";

export const GET_ALL_ESTADO = gql`
query GetAllPlanCuidadoEstado {
    allPlanCuidadoEstado{
            idPlanCuidadoEstado,
            nombre            
      }
}`;